/* ============================================================
   OXS Audio EU — Header interactions
   Mobile drawer (slide-in), accordion sub-menus, scroll progress.
   Cart is handled by Dawn's native cart-drawer (#cart-icon-bubble).
   Megamenu + locale are pure CSS (:hover / :focus-within).
   ============================================================ */
(() => {
  /* ─── Scroll progress bar (JS-driven for reliability across browsers) ─── */
  const bar = document.getElementById('progress');
  if (bar) {
    bar.style.display = 'block';
    let ticking = false;
    const paint = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      bar.style.transform = `scaleX(${max > 0 ? h.scrollTop / max : 0})`;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  /* ─── Mobile drawer ─── */
  const drawer = document.getElementById('mobileDrawer');
  const hamburger = document.getElementById('navHamburger');
  const closeBtn = document.getElementById('drawerClose');
  const backdrop = document.getElementById('drawerBackdrop');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.focus();
    }
  };

  /* Focus trap: while the drawer is open, Tab cycles within it. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
    const focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  /* Accordion sub-items inside the drawer */
  document.querySelectorAll('.mobile-drawer__link').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  /* Close drawer on ESC; also close the CSS :focus-within desktop megamenu by
     moving focus back to its top-level link (a11y — keyboard users can dismiss it). */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); return; }
    const openMega = document.activeElement && document.activeElement.closest('.nav__mega');
    if (openMega) {
      const item = openMega.closest('.nav__item');
      const trigger = item && item.querySelector('.nav__link');
      if (trigger) trigger.focus(); else document.activeElement.blur();
    }
  });
})();
